const homeBannerSlider = new Swiper('.homeBannerSection .homeBanner', {
  slidesPerView:1,
  spaceBetween:10,
  loop:true,
  /*pagination:{el:'.swiper-pagination',clickable:true},*/
  navigation:{nextEl:'.swiper-button-next',prevEl:'.swiper-button-prev'},
  autoplay:{delay:4000,disableOnInteraction:false},
});
/*----*/
/* FAQ */
window.document.onload = function(e){ toggleAccordion();}
function toggleAccordion(element) {
    const content = element.nextElementSibling;
    const parent = element.parentElement;
    const icon = element.querySelector('span');
    const minusIcon = `<svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"><g><path d="M7.08203 17H26.9154" stroke="black" stroke-opacity="0.5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></g></svg>`;
    const plusIcon = `<svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"><g><path d="M17 7.08203V26.9154" stroke="black" stroke-opacity="0.5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M7.08203 17H26.9154" stroke="black" stroke-opacity="0.5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></g></svg>`;
    if (parent.classList.contains('active')) {
        parent.classList.remove('active');
        icon.innerHTML = plusIcon;
        content.style.height = '0px';
    } else {
        document.querySelectorAll('.accordion-item').forEach(item => {
            item.classList.remove('active');
            item.querySelector('span').innerHTML = plusIcon;
            item.querySelector('.accordion-content').style.height = '0px';
        });
        parent.classList.add('active');
        icon.innerHTML = minusIcon;
        content.style.height = content.scrollHeight + 'px';
    }
}
/* FAQ end */

document.querySelectorAll('.pack-selection').forEach(function (pack) {
    const label = pack.querySelector('.pack-label');
    if (label && label.textContent.trim() === 'Title:') {
        pack.style.display = 'none'; // Hides the entire div
    }
});


(function updateLinkUrl() {
  // Check if the element with ID "__ourExperts" exists
  const targetElement = document.querySelector("#__ourExperts");

  // Check if the <a> tag exists
  const linkElement = document.querySelector("#HeaderMenu-expert-advice");

  // If both elements exist, update the URL of the <a> tag
  if (targetElement && linkElement) {
    const baseUrl = window.location.href; // Get the base URL
    // console.log("baseUrl", baseUrl);
    linkElement.href = `${baseUrl}/#__ourExperts`; // Update the href attribute
    linkElement.addEventListener("click", (event) => {
      event.preventDefault(); // Prevent default link behavior
      targetElement.scrollIntoView({ behavior: "smooth" }); // Smoothly scroll to the target section
    });
  }
})();


document.querySelectorAll('a[href^="#"]').forEach((link) => {
  link.addEventListener("click", (event) => {
    event.preventDefault(); // Prevent default link behavior
    const targetId = link.getAttribute("href").substring(1); // Get the target ID
    const targetElement = document.getElementById(targetId); // Find the target element

    if (targetElement) {
      targetElement.scrollIntoView({ behavior: "smooth" }); // Smooth scroll to the target element
    }
  });
});

